import React from 'react';
import { Link } from 'react-router';
import { Button } from '../../../components/Button';
import { Card } from '../../../components/Card';
import { PlaceholderImage } from '../../../components/PlaceholderImage';
import { Section } from '../../../components/Section';
import { partners } from '../data/partners';

export const PartnersPreview: React.FC = () => {
  return (
    <Section>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '32px',
        }}
      >
        <h2
          style={{
            fontSize: '34px',
            fontWeight: 700,
            color: 'var(--text)',
          }}
          className="sectionTitle"
        >
          Partners
        </h2>
        <Link to="/partners" style={{ textDecoration: 'none' }}>
          <Button variant="secondary">See partners</Button>
        </Link>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
        }}
        className="partnersGrid"
      >
        {partners.map((partner) => (
          <Card key={partner.id} hoverable>
            <PlaceholderImage
              label={partner.logoLabel}
              height={120}
              style={{ marginBottom: '16px' }}
            />
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: 'var(--text)',
                marginBottom: '8px',
              }}
            >
              {partner.name}
            </h3>
            <p
              style={{
                fontSize: '13px',
                color: 'var(--g1)',
                marginBottom: '12px',
                fontWeight: 500,
              }}
            >
              {partner.role}
            </p>
            <p
              style={{
                color: 'var(--muted)',
                fontSize: '14px',
                lineHeight: 1.6,
              }}
            >
              {partner.description.substring(0, 120)}...
            </p>
          </Card>
        ))}
      </div>
    </Section>
  );
};

